package modysy.model

import modysy.datastructures.Vector2

/** Represents velocity of the body in 2D space. */
class Velocity(var linear: Vector2, var angular: Double) {
  def isZero: Boolean = linear == Vector2(0, 0) && angular == 0
}

object Velocity {

  /** Return zero velocity (zero translational and zero rotational velocity). */
  def zero: Velocity = new Velocity((0, 0), 0)
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Velocity.scala